<template>
  <button
    class="orange-button"
    :class="{ 'no-icon-button': !displayIcon }"
    @mousedown="isClicked = !isClicked"
    @mouseup="isClicked = !isClicked"
    @click="navigate"
  >
    {{ title }}
    <TopArrowIcon v-if="displayIcon" :clicked="isClicked" class="arrow-icon" />
  </button>
</template>

<script>
import TopArrowIcon from '../../assets/iconTemplates/TopArrowIcon.vue';
export default {
  components: {
    TopArrowIcon,
  },
  props: {
    title: {
      type: [String, undefined],
      required: true,
    },
    displayIcon: {
      type: Boolean,
      default: true,
    },
    isBlogCard: {
      type: Boolean,
      default: false,
    },
    href: {
      type: [String, undefined],
      default: undefined,
    },
  },
  data() {
    return {
      isClicked: false,
    };
  },
  computed: {
    routeUrl() {
      return this.href ? `/${this.href}` : '/request-demo';
    },
  },
  methods: {
    navigate() {
      if (this.isBlogCard) return;

      this.$router.push(this.routeUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';
@import '../../assets/css/fonts';

.arrow-icon {
  height: 30px;
  width: 30px;
}

.orange-button {
  @include Aspekta-font(650, $dynamic-main-check-button-font-size, normal, #ffffff);
  background-color: $new-orange-color;
  border:
    2px solid linear-gradient(0deg, rgba(255, 122, 8, 0.7) 100%),
    var(--white, #fff);
  border-radius: 36px;
  padding: 15px 15px 15px 30px;
  text-decoration: none;
  display: flex;
  gap: 15px;
  align-items: center;

  &:hover {
    background:
      linear-gradient(0deg, rgba(255, 122, 8, 0.7) 0%, rgba(255, 122, 8, 0.7) 100%),
      var(--white, #fff);
    border:
      2px solid linear-gradient(0deg, rgba(255, 122, 8, 0.7) 0%, rgba(255, 122, 8, 0.7) 100%),
      var(--white, #fff);
    animation-duration: 150ms;
    animation-timing-function: ease-out;
  }

  &:active {
    color: #242424;
    border:
      2px solid linear-gradient(0deg, rgba(255, 122, 8, 0.7) 0%, rgba(255, 122, 8, 0.7) 100%),
      var(--white, #fff);
    background: var(--white, #fff);
    animation-duration: 200ms;
    animation-timing-function: ease-out;
  }
}

.no-icon-button {
  padding: 18px 30px;
}

.no-icon-button:active {
  color: $new-orange-color;
  border-color: $new-orange-color;
}

@media (max-width: 768px) {
  .orange-button {
    gap: 8px;
    width: max-content;
  }

  .arrow-icon {
    height: 22px;
    width: 22px;
  }
}
</style>
